import styled from 'styled-components';

export const FinancingProposalFormsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 24px;
  border-radius: 8px;
  /* Mesmo motivo do TableWrapperContainer: deixa o card encolher para a tabela
     rolar por dentro, em vez de o scroll vazar para a pagina. */
  min-height: 0;
  overflow: hidden;
`;

export const FinancingProposalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  align-items: center;
`;

export const FormSpacing = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  height: 20px;
`;

// 🔵 Botão independente, com estilo 100% controlado
export const EspelhoButton = styled.button`
  margin-left: auto;
  background-color: #007bff;
  color: #ffffff;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.3s ease,
    transform 0.1s ease;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background-color: #a0c8f0;
    cursor: not-allowed;
  }
`;
